import React, { useState } from "react";
import { auth } from "../firebase";
import { signInWithEmailAndPassword } from "firebase/auth";
import { message } from "antd";
import { useNavigate } from "react-router-dom";

export default function LoginPage() {
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPw, setShowPw] = useState(false);
  const [dark, setDark] = useState(() => localStorage.getItem("ws-theme") === "dark");
  const navigate = useNavigate();

  const toggleTheme = () => {
    setDark((d) => {
      localStorage.setItem("ws-theme", !d ? "dark" : "light");
      return !d;
    });
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!email || !password) {
      message.error("Veuillez remplir tous les champs");
      return;
    }
    setLoading(true);
    try {
      const result = await signInWithEmailAndPassword(auth, email, password);
      message.success("Connexion réussie");
      navigate("/home", { state: { uid: result.user.uid } });
    } catch (err) {
      message.error("Identifiants incorrects");
    }
    setLoading(false);
  };

  const t = dark ? theme.dark : theme.light;

  return (
    <div style={{ background: t.bg, minHeight: "100vh", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: 20 }}>

      {/* Theme toggle */}
      <div style={{ position: "absolute", top: 20, right: 20 }}>
        <button
          onClick={toggleTheme}
          aria-label="Changer le thème"
          style={{ ...s.toggleTrack, background: t.bg3, border: `1px solid ${t.border}` }}
        >
          <div style={{ ...s.toggleKnob, background: t.blue, transform: dark ? "translateX(16px)" : "translateX(0)" }} />
        </button>
      </div>

      {/* Card */}
      <div style={{ ...s.card, background: t.cardBg, border: `1px solid ${t.border}`, width: "100%", maxWidth: 380 }}>

        {/* Logo + heading */}
        <div style={{ textAlign: "center", marginBottom: 28 }}>
          <img src="/logo.PNG" alt="WeStudy" style={{ height: 64, objectFit: "contain", marginBottom: 16 }} />
          <div style={{ fontSize: 20, fontWeight: 600, color: t.text1 }}>Connexion</div>
          <div style={{ fontSize: 13, color: t.text2, marginTop: 4 }}>Bienvenue chez WeStudy</div>
        </div>

        {/* Form */}
        <form onSubmit={onSubmit} style={{ display: "flex", flexDirection: "column", gap: 16 }}>

          <div>
            <label style={{ fontSize: 12, fontWeight: 500, color: t.text2, display: "block", marginBottom: 6 }}>
              Email
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="exemple@domain.com"
              required
              style={{ ...s.input, background: t.bg3, border: `1px solid ${t.border}`, color: t.text1 }}
            />
          </div>

          <div>
            <label style={{ fontSize: 12, fontWeight: 500, color: t.text2, display: "block", marginBottom: 6 }}>
              Mot de passe
            </label>
            <div style={{ position: "relative" }}>
              <input
                type={showPw ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                required
                style={{ ...s.input, background: t.bg3, border: `1px solid ${t.border}`, color: t.text1, paddingRight: 44 }}
              />
              <button
                type="button"
                onClick={() => setShowPw((v) => !v)}
                style={{ position: "absolute", right: 12, top: "50%", transform: "translateY(-50%)", background: "none", border: "none", cursor: "pointer", fontSize: 16, color: t.text3, padding: 0, lineHeight: 1 }}
              >
                {showPw ? "🙈" : "👁️"}
              </button>
            </div>
          </div>

          <button
            type="submit"
            disabled={loading}
            style={{ ...s.submitBtn, background: loading ? t.border : t.blue, color: loading ? t.text3 : "#fff", cursor: loading ? "not-allowed" : "pointer", marginTop: 4 }}
          >
            {loading ? "Connexion..." : "Se connecter"}
          </button>

        </form>
      </div>
    </div>
  );
}

const theme = {
  light: {
    bg: "#f8fafc", bg3: "#f1f5f9", border: "#e2e8f0",
    text1: "#0f172a", text2: "#64748b", text3: "#94a3b8",
    blue: "#2563eb", cardBg: "#ffffff",
  },
  dark: {
    bg: "#0f172a", bg3: "#1a2740", border: "#273549",
    text1: "#f1f5f9", text2: "#94a3b8", text3: "#475569",
    blue: "#378ADD", cardBg: "#1e293b",
  },
};

const s = {
  card: { borderRadius: 16, padding: 28 },
  input: {
    width: "100%", height: 42, borderRadius: 10, padding: "0 14px",
    fontSize: 14, outline: "none", boxSizing: "border-box",
    transition: "border-color 0.15s",
  },
  submitBtn: {
    width: "100%", height: 44, borderRadius: 10, border: "none",
    fontSize: 14, fontWeight: 600, transition: "background 0.15s",
  },
  toggleTrack: { width: 36, height: 20, borderRadius: 20, cursor: "pointer", position: "relative", flexShrink: 0 },
  toggleKnob: { width: 14, height: 14, borderRadius: "50%", position: "absolute", top: 2, left: 2, transition: "transform 0.2s" },
};